import * as routesPlanningApi from "../../backend/routesPlanningApi.js";
import { phaseTypes } from "../../views/routes-planning/components/shipping-phase-types.js";
import { placingTypes } from "../../views/routes-planning/components/shipping-placing-types.js";
import * as dataListApi from "../../backend/dataListApi.js";

const state = {
  directions: [],
  phases: [],
  routes: [],
  drafts: [],
  planningRoutes: [],
  planningData: [],
  destinationCountries: [],
  sendingCountries: [],
  phaseType: null,
  shippingState: null,
  selectedSetting: null,
  columns: [],
  savedSettings: [],
  routesColors: [
    "#D1C4E9",
    "#FFCDD2",
    "#F8BBD0",
    "#B2EBF2",
    "#C8E6C9",
    "#F0F4C3",
    "#FFE0B2",
    "#D7CCC8",
    "#FFAB91",
    "#9FA8DA",
    "#DCEDC8",
    "#BBDEFB",
    "#B0BEC5",
    "#F06292",
    "#BA68C8",
    "#EF5350",
    "#5E35B1",
    "#80DEEA",
    "#26A69A",
    "#DCE775",
    "#66BB6A",
    "#A1887F",
    "#FF8A65",
    "#FFECB3",
    "#558B2F",
    "#E1BEE7",
    "#A7FFEB",
  ],
  headers: [
    {
      title: "",
      name: "",
      sortable: false,
      type: "icon",
      iconType: "filter_list",
      notCustomizable: true,
      minWidth: 30,
      order: 0,
      visible: true,
    },
    {
      title: "Ознакомлен",
      name: "isFamiliarized",
      sortable: false,
      type: "checkbox",
      minWidth: 30,
      order: 0,
      visible: true,
    },
    {
      title: "Регион",
      name: "region",
      type: "object",
      sortable: false,
      regionColor: true,
      cellFiltering: true,
      compactMaxLength: 9,
    },
    {
      title: "Область",
      name: "district",
      type: "object",
      sortable: false,
      cellColor: true,
      cellFiltering: true,
      compactMaxLength: 9,
    },
    {
      title: "Город погрузки",
      name: "city",
      type: "object",
      sortable: false,
      cellColor: true,
      maxLength: 20,
      cellFiltering: true,
      compactMaxLength: 9,
    },
    {
      title: "Индекс",
      name: "postcode",
      sortable: false,
      cellColor: true,
      cellFiltering: true,
    },
    {
      title: "Место погрузки",
      name: "loadingPlace",
      valueFn(value) {
        if (typeof value.loadingPlace === "object") {
          return value.loadingPlace.warehouse
            ? value.loadingPlace.warehouse.title
            : value.loadingPlace.factory
              ? value.loadingPlace.factory.title
              : value.loadingPlace.address
                ? value.loadingPlace.address.title
                : "";
        } else {
          return value.loadingPlace;
        }
      },
      sortable: false,
      routeColor: true,
      cellColor: true,
      maxLength: 20,
      cellFiltering: true,
      compactMaxLength: 8,
      compact: "string",
    },
    {
      title: "№ маршрута",
      name: "route",
      name2: "draft",
      sortable: false,
      notCustomizable: true,
      routeColor: true,
      cellColor: true,
      compact: "compactObject",
      type: "object",
    },
    {
      title: "Объем",
      name: "volume",
      sortable: false,
      cellColor: true,
    },
    {
      title: "Вес",
      name: "weight",
      sortable: false,
      cellColor: true,
    },
    {
      title: "Поставка",
      name: "shipping",
      sortable: false,
      cellColor: true,
    },
    {
      title: "Описание",
      name: "productDescription",
      cellColor: true,
      sortable: true,
      cellFiltering: true,
      maxLength: 10,
      compactMaxLength: 8,
      compact: "string",
    },
    {
      title: "Продавец",
      name: "sender",
      sortable: false,
      cellColor: true,
      maxLength: 20,
      compactMaxLength: 8,
      compact: "string",
    },
    {
      title: "Клиент",
      name: "client",
      type: "object",
      cellColor: true,
      sortable: true,
      cellFiltering: true,
      compactMaxLength: 8,
    },
    {
      title: "Клиент по документам",
      name: "clientAlias",
      cellColor: true,
      sortable: true,
      cellFiltering: true,
      compactMaxLength: 8,
      compact: "string",
    },
    {
      title: "Референс погрузки",
      name: "loadingNumber",
      cellColor: true,
      sortable: false,
      compactMaxLength: 8,
      compact: "string",
    },
    {
      title: "Дата готовности",
      name: "readyDate",
      type: "date",
      sortable: false,
      cellColor: true,
    },
    {
      title: "Желаемая дата доставки",
      name: "deliveryToUnloadingPlaceDate",
      type: "date",
      sortable: false,
      cellColor: TextTrackCueList,
    },
    {
      title: "Дата закрытия фабрики",
      name: "factoryClosingDate",
      type: "date",
      sortable: false,
      cellColor: true,
      edit: true,
    },
    {
      title: "Склад",
      name: "warehouse",
      valueFn(value) {
        if (typeof value.warehouse === "object") {
          return value.warehouse.warehouse
            ? value.warehouse.warehouse.title
            : value.warehouse.factory
              ? value.warehouse.factory.title
              : value.warehouse.address
                ? value.warehouse.address.title
                : "";
        } else {
          return value.warehouse;
        }
      },
      sortable: false,
      cellColor: true,
      cellFiltering: true,
      compactMaxLength: 8,
      compact: "string",
    },
    {
      title: "Тип звена",
      name: "phaseType",
      sortable: false,
      type: "object",
      cellColor: true,
      compact: "compactObject",
    },
    {
      title: "Статус на складе",
      name: "warehouseType",
      sortable: false,
      cellColor: true,
    },
    {
      title: "Прибытие на склад",
      name: "arriveToWarehouseDate",
      type: "date",
      sortable: false,
      cellColor: true,
      tooltip: true,
    },
    {
      title: "Погрузка в машину",
      name: "carLoadingDate",
      type: "date",
      sortable: false,
      cellColor: true,
      tooltip: true,
    },
    {
      title: "Комментарий по погрузке",
      name: "cargoComment",
      sortable: false,
      cellColor: true,
      tooltip: true,
    },
    {
      title: "Направление",
      name: "direction",
      sortable: false,
      visible: false,
      hidden: true,
    },
    {
      title: "Метка в машине",
      name: "inCar",
      sortable: false,
      visible: false,
      hidden: true,
    },
    {
      title: "Звено",
      name: "phaseId",
      sortable: false,
      visible: false,
      hidden: true,
    },
    {
      title: "",
      type: "menu",
      sortable: false,
      visible: true,
      hidden: true,
    },
  ],
  filterIsActive: false,
  dataTableFilter: null,
  savedFilters: [],
  quickFilter: null,
  isShared: false,
  planningFilter: null,
  planningQuickFilter: null,
  savedPlanningFilters: [],
  compactMode: false,
  editableRouteItem: null,
  changedItemRow: false,
};

const getters = {
  directions: state => {
    return state.directions;
  },
  phases: state => {
    return state.phases;
  },
  drafts: state => {
    return state.drafts;
  },
  planningRoutes: state => {
    return state.planningRoutes;
  },
  destinationCountries(state) {
    return state.destinationCountries;
  },
  sendingCountries(state) {
    return state.sendingCountries;
  },
  phaseType(state) {
    return state.phaseType;
  },
  shippingState(state) {
    return state.shippingState;
  },
  columns(state) {
    return state.columns;
  },
  savedSettings(state) {
    return state.savedSettings;
  },
  selectedSetting(state) {
    return state.selectedSetting;
  },
  routesColors(state) {
    return state.routesColors;
  },
  getPlanningData(state) {
    return state.planningData;
  },
  headers(state) {
    return state.headers;
  },
  getRoutes(state) {
    return state.routes;
  },
  filterIsActive(state) {
    return state.filterIsActive;
  },
  dataTableFilter(state) {
    return state.dataTableFilter;
  },
  savedFilters(state) {
    return state.savedFilters;
  },
  quickFilter(state) {
    return state.quickFilter;
  },
  isShared(state) {
    return state.isShared;
  },
  planningFilter(state) {
    return state.planningFilter;
  },
  planningQuickFilter(state) {
    return state.planningQuickFilter;
  },
  savedPlanningFilters(state) {
    return state.savedPlanningFilters;
  },
  compactMode(state) {
    return state.compactMode;
  },
  editableRouteItem(state) {
    return state.editableRouteItem;
  },
  changedItemRow(state) {
    return state.changedItemRow;
  },
};

const actions = {
  async getPlanningRoutes({ commit, getters }) {
    const routes = await routesPlanningApi.getRoutes();
    commit("setRoutes", routes);
    const routeItems = routes.map(r => {
      const route = {
        routeId: r.id,
        draftId: 0,
        title: r.title,
        prefixCountry: r.title.replace(/[0-9]/g, ""),
        number: r.title.replace(/\D+/g, ""),
        direction: r.direction,
        routeColor: assignColor(r.title.replace(/\D+/g, "") - 1),
        phases: r.phases,
        summaryInfo: getSummaryInfo(r.phases),
        logist: r.logist,
      };
      return route;
    });

    const drafts = await routesPlanningApi.getDrafts();
    commit("setDrafts", drafts);
    const draftItems = drafts.map(d => {
      const draft = {
        routeId: 0,
        draftId: d.id,
        title: `${d.title}(n)`,
        prefixCountry: d.title.replace(/[0-9]/g, ""),
        number: d.title.replace(/\D+/g, ""),
        direction: d.direction,
        routeColor: assignColor(d.title.replace(/\D+/g, "") - 1),
        phases: d.phases,
        summaryInfo: getSummaryInfo(d.phases),
      };
      return draft;
    });
    const planningRoutes = routeItems.concat(draftItems);
    planningRoutes.sort((a, b) => {
      if (a.prefixCountry === b.prefixCountry) {
        if (+a.number < +b.number) {
          return -1;
        } else if (+a.number > +b.number) {
          return 1;
        } else {
          return 0;
        }
      }
      if (a.prefixCountry !== b.prefixCountry) {
        if (a.prefixCountry < b.prefixCountry) {
          return -1;
        } else if (a.prefixCountry > b.prefixCountry) {
          return 1;
        } else {
          return 0;
        }
      }
    });
    commit("setPlanningRoutes", planningRoutes);

    function assignColor(routeIndex) {
      let diff = +routeIndex;
      while (diff > getters.routesColors.length - 1) {
        diff = diff - (getters.routesColors.length - 1);
      }
      return getters.routesColors[diff];
    }
    function getSummaryInfo(phases) {
      let weight = 0;
      let volume = 0;
      let cargoPlaces = 0;

      if (phases) {
        phases.forEach(p => {
          weight += p.weight;
          volume += p.volume;
          cargoPlaces += p.cargoPlaces;
        });
      }
      return {
        weight,
        volume,
        cargoPlaces,
      };
    }
  },
  async getPhasesRoutePlanning({ state, getters, commit }) {
    const filter = {};
    filter.shippingPlacingType = getters.shippingState?.notInRoute
      ? placingTypes.NOTINROUTE
      : getters.shippingState?.notInCar
        ? placingTypes.NOTINCAR
        : placingTypes.ANY;
    filter.shippingDeliveryType = getters.phaseType?.pickup
      ? phaseTypes.PICKUP
      : getters.phaseType?.combination
        ? phaseTypes.COMBINATION
        : phaseTypes.ANY;
    filter.countryId = getters.directions.map(c => c.value);
    filter.destinationCountryId = getters.destinationCountries.map(
      d => d.value,
    );
    filter.sendingCountryId = getters.sendingCountries.map(s => s.value);

    const items = await routesPlanningApi.getPhasesRoutePlanning(filter);
    commit("setPhases", items);
    items.forEach(i => {
      if (!i.route) {
        const draft = getters.drafts.find(d =>
          d.phases.find(s => s.phaseId === i.phaseId),
        );
        if (draft) {
          i.draft = {
            title: `${draft.title}(n)`,
            id: draft.id,
          };
          i.routeColor = assignColor(draft.title.replace(/\D+/g, "") - 1);
        }
      } else if (i.route) {
        i.routeColor = assignColor(i.route.title.replace(/\D+/g, "") - 1);
        const route = getters.getRoutes.find(r =>
          r.phases.find(p => p.phaseId === i.phaseId),
        );
        const routeItemId = route?.phases.find(p => p.phaseId === i.phaseId)
          .routeItemId;
        if (routeItemId) {
          i.routeItemId = routeItemId;
        }
      } else {
        return;
      }
    });
    const phases = items.map(i => {
      const item = { ...i };
      state.headers.forEach(h => {
        if (h.type === "icon") {
          return;
        }
        if (h.valueFn) {
          item[h.name] = h.valueFn(i);
        } else if (h.name2) {
          item[h.name] = i[h.name];
          item[h.name2] = i[h.name2];
        } else {
          item[h.name] = i[h.name];
        }
      });
      return item;
    });
    commit("setPlanningData", phases);

    function assignColor(routeIndex) {
      let diff = +routeIndex;
      while (diff > getters.routesColors.length - 1) {
        diff = diff - (getters.routesColors.length - 1);
      }
      return getters.routesColors[diff];
    }
  },
  async getSavedFilters({ commit }) {
    const filters = await dataListApi.getSavedFiltersByPage("routePlanning");
    commit("setSavedFilters", filters);
  },
  async getSavedPlanningFilters({ commit }) {
    const filters = await dataListApi.getSavedFiltersByPage(
      "routePlanningItems",
    );
    commit("setSavedPlanningFilters", filters);
  },
};

const mutations = {
  setDirections(state, directions) {
    state.directions = directions;
  },
  setPhases(state, phases) {
    state.phases = phases;
  },
  setDrafts(state, drafts) {
    state.drafts = drafts;
  },
  setPlanningRoutes(state, routes) {
    state.planningRoutes = routes;
  },
  setDestinationCountries(state, destinationCountries) {
    state.destinationCountries = destinationCountries;
  },
  setSendingCountries(state, sendingCountries) {
    state.sendingCountries = sendingCountries;
  },
  setPhaseType(state, phaseType) {
    state.phaseType = phaseType;
  },
  setShippingState(state, shippingState) {
    state.shippingState = shippingState;
  },
  setColumns(state, columns) {
    state.columns = columns;
  },
  setSavedSettings(state, savedSettings) {
    state.savedSettings = savedSettings;
  },
  setSelectedSetting(state, selected) {
    state.selectedSetting = selected;
  },
  setPlanningData(state, planningData) {
    state.planningData = planningData;
  },
  setRoutes(state, routes) {
    state.routes = routes;
  },
  setFilterIsActive(state, value) {
    state.filterIsActive = value;
  },
  setDataTableFilter(state, value) {
    state.dataTableFilter = value;
  },
  setSavedFilters(state, value) {
    state.savedFilters = value;
  },
  setQuickFilter(state, value) {
    state.quickFilter = value;
  },
  setIsShared(state, value) {
    state.isShared = value;
  },
  setPlanningFilter(state, value) {
    state.planningFilter = value;
  },
  setPlanningQuickFilter(state, value) {
    state.planningQuickFilter = value;
  },
  setSavedPlanningFilters(state, value) {
    state.savedPlanningFilters = value;
  },
  setCompactMode(state, value) {
    state.compactMode = value;
  },
  setEditableRouteItem(state, value) {
    state.editableRouteItem = value;
  },
  setChangedItemRow(state, value) {
    state.changedItemRow = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
